const url = {
  getSecret2fa: '/ajax/user/2fa/get-secret',
  enable2fa: '/ajax/user/2fa/enable',
  disable2fa: '/ajax/user/2fa/disable',
  backupCodes2fa: '/ajax/user/2fa/backup-codes',
};


export default url;
